

const FormulaReelWeightCalculation = async (reel_length, gsm, achieved_Deckle, setWeight, setSetWeight) => {

    let reelWeightcalculation = (reel_length * gsm * achieved_Deckle) / 100000000;
    setSetWeight(reelWeightcalculation.toFixed(3)); // Round to 3 decimal places for better precision
  
}
export default FormulaReelWeightCalculation;


